import { useEffect } from 'react';
import StaffSignUpForm from 'src/content/applications/Login/StaffSignupForm';
import AuthPrompt from './AuthPrompt';
import { useAuth, UIState } from '../../../hooks/useAuth';

function Status404() {
  const { setAuthState, authState, signIn } = useAuth();

  useEffect(() => {
    // Store the accessToken and displayName in localStorage if they are not null
    if (authState.uiState == null && authState.accessToken != null) {
      if (authState.displayName) {
        // Ensure displayName is not undefined
        localStorage.setItem('displayName', authState.displayName);
      }
      localStorage.setItem('accessToken', authState.accessToken);

      if (window.location.href.includes('login')) {
        window.location.href = '/product';
      } else {
        window.location.reload();
      }
    }
  }, [authState.accessToken, authState.uiState, authState.displayName]);

  useEffect(() => {
    // Store the accessToken in the localstorage
    if (authState.uiState == null && authState.accessToken != null) {
      localStorage.setItem('accessToken', authState.accessToken);
      localStorage.setItem('displayName', authState.displayName);

      if (window.location.href.includes('login')) {
        window.location.href = '/product';
      } else {
        window.location.reload();
      }
    }
  }, [authState.accessToken, authState.uiState]);

  return (
    <>
      {authState.uiState == UIState.register && (
        <StaffSignUpForm accessToken={authState.accessToken} />
      )}
      {authState.uiState == UIState.inactive && (
        <h1>Your account is not active</h1>
      )}
      {authState.uiState == UIState.login && (
        <AuthPrompt authState={authState} signIn={signIn} />
      )}
    </>
  );
}

export default Status404;
